// src/Blogs.js

import React from 'react';
import {
    Container,
    Grid,
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import StarIcon from '@mui/icons-material/Star';
import heroImage from '../assets/hero-image-digital-finance.jpg'; // Ensure this path is correct
import blogs from './blogsData'; // Import the blogs data
import { styled } from '@mui/material/styles';
import theme from '../theme'; // Import your theme
const palette = {
    skyBlue: '#87CEFA',
    lavender: '#E6E6FA',
    white: '#FFFFFF',
    gold: '#DAA520',
    darkBlue: '#122652',
    orange: 'rgb(238, 90, 0)',
};
// Styled component for the hero section with dark overlay
const ImageSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '50vh', // Adjust the height as needed
    backgroundImage: `url(${heroImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'left',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
    // Adding the dark overlay using a pseudo-element
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 50% black
        zIndex: 1,
    },
    // Ensuring that the child elements are above the overlay
    '& > *': {
        position: 'relative',
        zIndex: 2,
    },
}));

// Styled component for the content within the hero section
const ImageContent = styled(Container)(({ theme }) => ({
    color: theme.palette.common.white,
}));

function Blogs() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Hero Section with Background Image */}
            <ImageSection>
                <ImageContent>
                    <Typography
                        variant="h2"
                        gutterBottom
                        sx={{
                            color: 'white'
                            
                        }}
                    >
                        Vinkkejä rahoitukseen
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                                 color: 'white'
                        }}
                    >
                        Rahoituskanava auttaa yritystäsi löytämään parhaat rahoitusratkaisut
                    </Typography>
                </ImageContent>
            </ImageSection>

            {/* Main Content */}
            <Container sx={{ flex: 1, p: 2 }}>
                <Grid container spacing={4}>
                    {blogs
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                        .map((blog) => (
                        <Grid item xs={12} md={6} key={blog.id}>
                            <Card sx={{ borderRadius: '10px' }}>
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={blog.image}
                                    alt={blog.title}
                                />
                                <CardContent>
                                    <Typography
                                        variant="subtitle2"
                                        gutterBottom
                                        sx={{
                                        }}
                                    >
                                        {new Date(blog.date).toLocaleDateString('fi-FI', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}, author: {blog.author}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        sx={{
                                        }}
                                    >
                                        {blog.title}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        gutterBottom
                                    >
                                        {blog.excerpt}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button
                                        component={RouterLink}
                                        to={`/blogs/${blog.url}`}
                                        color="primary"
                                        variant="outlined"
                                        aria-label={`Read more about ${blog.title}`}
                                    >
                                        Lue lisää
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {/* Additional Information Section */}
         

                {/* Action Buttons */}
                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to="/yrityslaina"
                        sx={{
                            background: `linear-gradient(90deg, ${palette.orange} 60%, #ffb347 100%)`,
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: { xs: '1.1rem', md: '1.2rem' },
                            padding: { xs: '16px 0', md: '12px 32px' },
                            borderRadius: '30px',
                            width: { xs: '100%', md: 'auto' },
                            boxShadow: '0 4px 16px 0 rgba(238,90,0,0.15)',
                            transition: 'transform 0.15s, box-shadow 0.15s',
                            '&:hover, &:focus': {
                                background: palette.orange,
                                color: 'white',
                                transform: 'scale(1.04)',
                                boxShadow: '0 6px 24px 0 rgba(238,90,0,0.25)',
                            },
                        }}
                        aria-label="Aloita yrityslainahakemus"
                    >
                        Aloita yrityslainahakemus
                    </Button>
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to="/laskurahoitus"
                        sx={{
                            background: `linear-gradient(90deg, ${palette.orange} 60%, #ffb347 100%)`,
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: { xs: '1.1rem', md: '1.2rem' },
                            padding: { xs: '16px 0', md: '12px 32px' },
                            borderRadius: '30px',
                            width: { xs: '100%', md: 'auto' },
                            boxShadow: '0 4px 16px 0 rgba(238,90,0,0.15)',
                            transition: 'transform 0.15s, box-shadow 0.15s',
                            '&:hover, &:focus': {
                                background: palette.orange,
                                color: 'white',
                                transform: 'scale(1.04)',
                                boxShadow: '0 6px 24px 0 rgba(238,90,0,0.25)',
                            },
                        }}
                        aria-label="Aloita laskurahoitushakemus"
                    >
                        Aloita laskurahoitushakemus
                    </Button>
                </Box>
            </Container>

            
        </Box>
    );

}

export default Blogs;
